(function () {
	'use strict';

	angular.module('l4b')
		.controller('MyAccountController', MyAccountController);

	MyAccountController.$inject = ['$state', '$scope', '$location', 'Constants', 'FlowService', 'MyAccountService', 'Utils', 'DTOFactory', '$rootScope', '$stateParams', 'StorageService', 'PageInfoService'];

	function MyAccountController($state, $scope, $location, Constants, FlowService, MyAccountService, Utils, DTOFactory, $rootScope, $stateParams, StorageService, PageInfoService) {
		var vm = this,
			tab = null,
			myAccountState = $state.get(Constants.Page.MyAccount);

		angular.extend(vm, {
			// Injects
			Constants: Constants,

			// 
			$onInit: init,
			logOut: logOut,
			clickTab: MyAccountService.GoTo,
			pages: Constants.Page,
			initialized: false,
			showSubmitDocumentation: false,
			isVerizonForwardFlow: false,
			enrollment: null,
			showUpdateInfo: true,
			showTabs: showTabs,
			activeTab: null,
			tabs: Constants.Page
		});

		$scope.$on('ebb-approved', function () {
			vm.showReprint = false;
		});

		$rootScope.$on('$locationChangeSuccess', function () {
			var path = $location.path();

			//If its already initialized and gets to myAccount base path, force init
			if (vm.initialized && path == myAccountState.url) {
				init();
			}

		})

		function init() {
			tab = $stateParams && $stateParams.tabSelected || Constants.Page.MyAccountDetails;

			if ($stateParams && !$stateParams.fromLogin) {
				MyAccountService.GetApplication(getApplicationCallback);
			}
			else {
				getApplicationCallback(true);
			}
			vm.initialized = true;
			if ($stateParams.brandCode) {
				var brandObj = Constants.Brand[$stateParams.brandCode];
				StorageService.set(Constants.SK.Brand, brandObj)
				PageInfoService.setInfoForBrand($stateParams.brandCode);
				$rootScope.brandCode = $stateParams.brandCode;

				var params = $location.search();
				params.brand = $stateParams.brandCode;
				$location.search(params);

			}
		}

		function getApplicationCallback(success) {

			if (success) {
				$rootScope.$broadcast('enrollment-changed');

				showTabs();

				if (tab != $state.current.name) {
					MyAccountService.GoTo(tab);
				}
			}
			else {
				FlowService.goToLogin();
			}
		}

		function logOut() {
			$rootScope.$broadcast('close-air-message');
			MyAccountService.LogOut();
		}

		function showTabs() {

			var application = DTOFactory.Application();
			var stepCode = Utils.getProofStepCode();

			vm.showSubmitDocumentation = application.hasPendingProof && application.Status.Code == Constants.Status.PENDING;
			vm.isVerizonForwardFlow = application.BenefitTypeCode == Constants.BenefitType.VZF;

			if (stepCode != null && stepCode == Constants.UploadProofStep.RequiredDocumentationSubmitSuccess) {
				vm.showSubmitDocumentation = false && application.Status.Code == Constants.Status.PENDING;
			}

			var showUpdate = application.Status.Code == Constants.Status.ENROLLED;
			var showCancel = application.Status.Code == Constants.Status.ENROLLED;

			vm.showUpdateInfo = showUpdate;

			var middleName = application.Applicant.MiddleName ? (' ' + toNameCase(application.Applicant.MiddleName)) : '';
			var secondLastName = application.Applicant.SecondLastName ? (' ' + toNameCase(application.Applicant.SecondLastName)) : '';

			vm.fullName = toNameCase(application.Applicant.FirstName)
				+ middleName
				+ ' '
				+ toNameCase(application.Applicant.LastName)
				+ secondLastName;

			MyAccountService.SetActionsVisibility(showUpdate, showCancel);
		}
		function toNameCase(str) {
			if (!str) return '';
			return String(str)
				.trim()
				.split(/\s+/)
				.map(word =>
					word.split(/([\-'])/).map(chunk => {
						if (chunk === '-' || chunk === "'") return chunk;
						return chunk ? chunk.charAt(0).toUpperCase() + chunk.slice(1).toLowerCase() : '';
					}).join('')
				)
				.join(' ');
		}

	}
})();
